import AdminWidget from '../AdminWidget.js';
import Ajax from '../../../../../common/js/Ajax.js';
import Form from '../../../../../common/js/form/Form.js';
import MessageUtils from '../../../../../common/js/MessageUtils.js';

import TEMPLATE from './FreeLicenseWidget.hbs';

export default class FreeLicenseWidget extends AdminWidget {

	constructor($widget) {
		super($widget);

		this.spinner();
		Ajax.rpc('/products', products => {
			$widget.html(TEMPLATE(products));
		}, error => {
			MessageUtils.error($widget, 'Failed to load products', error);
		});

		Form.onSubmit(this.$widget, action => {
			$widget.find('.js_result').empty();

			Ajax.rpc('/createFreeOrder', {
				quantity: action.findField('quantity').val(),
				product: action.findField('program').val(),
				lang: action.findField('lang').val()
			}, orderId => {
				window.location.href = '/admin/order?id=' + orderId;
			}, error => {
				action.error('Failed to create free-license order', error);
			});
		});
	}

}
